<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Cashiers</h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items
        v-if="permissions.includes('store_api_admin-panel_cashiers')"
        class="main-header__contents"
      >
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          to="/cashiers/create"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">Add Cashier</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="cashiers"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item ? item.name : "---" }}
          </td>
          <td class="table__cell text-center">
            {{ item ? item.location : "---" }}
          </td>
          <td class="table__cell text-center">
            {{ item ? item.lat : "---" }}
          </td>
          <td class="table__cell text-center">
            {{ item ? item.lng : "---" }}
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="`/cashiers/create/${item.id}`"
              class="hovering mr-1 edit"
              v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              "
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </router-link>
            <span
              v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              "
              @click="handleDelete(item, index)"
              class="hovering delete"
            >
              <v-icon small>mdi-delete</v-icon><br />
              Delete
            </span>
            <span v-else>---</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      cashiers: [],
      loadingDataTable: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexcashiers();
  },
  methods: {
    indexcashiers() {
      this.loadingDataTable = true;
      IndexData({ reqName: `cashiers` })
        .then(res => {
          const { data } = res.data;
          this.cashiers = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Name", "Locaton", "Lat", "Lng", "Actions"];
      this.headers = TableHeaders(headersList);
    },
    handleEdit() {},
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/cashiers`,
            id: id
          })
            .then(() => {
              this.cashiers.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
